<template>
  <div class="text-center">

    <span v-if="!isVerified && !isActivated">
      <br>
      <h1>Pending Approval</h1><br>
      <p>Your registration is pending and we will notify you by email whether your application is approved.</p>
      <p>For more enquiries, please contact us at <u>contact.rtl@lifertl.com</u>.</p>
      <br>
    </span>

    <span v-if="isVerified && !isActivated">
      <br>
      <h1>Please activate your account</h1><br>
      <p>An email has been sent to you at {{ userEmail }} with further instructions.</p>
      <br>
    </span>

    <span v-if="!isVerified && isActivated">
      <br>
      <h1>Account Suspended</h1><br>
      <p>Your email address is not found in the latest Membership Roll Update Exercise.</p>
      <p>Please write in to <u>admin@lifebpc.com</u> to verify your personal particulars with the Church Office.</p>
      <br>
    </span>

  </div>
</template>

<script>
export default {
  name: "EmptyHome",
  computed: {
    userEmail: function () {
      let userObj = this.$store.getters.getUser;
      let displayEmail = "";
      if (userObj != null) {
        if (userObj.email != null) {
          displayEmail = userObj.email;
        }
      }
      return displayEmail;
    },
    isVerified: function () {
      return this.$store.getters.isVerified;
    },
    isActivated: function () {
      return this.$store.getters.isActivated;
    },
  },
};
</script>
